import { useContext, useCallback } from 'react';
import _ from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { useWizardService } from '@bingads-webui-react/wizard';
import { saveAds, saveAdsWithMetadata } from '@bingads-webui-campaign-react/display-plus-native-ads';
import { getDefaultCampaign, getDefaultAdGroup } from './constants';
import { useAdsRepository } from '../../common/use-ads-repository';

export const useMultipleNativeAdsRepository = () => {
  const i18n = useContext(I18nContext);

  const serverContext = useContext(ServerContext);
  const isVideoAsAnAssetEnabled = serverContext.Permissions && serverContext.DynamicPermissions.VideoAsAnAsset && !serverContext.Permissions.IsAmplifyEnabled;
  const { state } = useWizardService();

  const { save } = useAdsRepository({
    saveAds: isVideoAsAnAssetEnabled ? saveAdsWithMetadata : saveAds,
    defaultCampaign: getDefaultCampaign(i18n, serverContext),
    defaultAdGroup: getDefaultAdGroup(i18n, serverContext),
  });


  const load = useCallback(() => new Promise((resolve) => {
    if (state.context.wizardData.editingAdId) {
      const { editingAdId } = state.context.wizardData;

      if (!editingAdId) {
        const ids = _.keys(state.context.wizardData.ads.ads);

        if (ids.length > 0) {
          resolve(state.context.wizardData.ads.ads[ids[0]]);
        }
      } else {
        resolve(state.context.wizardData.ads.ads[editingAdId] || {});
      }
    } else {
      resolve({
        data: [],
        isValid: false,
        isDirty: false,
        currentPageIndex: 1,
      });
    }
  }), [state.context.wizardData]);

  return {
    load,
    save,
  };
};
